import { ActivatedRoute } from '@angular/router';
import { BaseUpdateComponent, BaseDataService, QueryParameter, ModalService, NotificationService } from 'yt-ng-framework';
import { Component, OnInit } from "@angular/core";
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { KursDokument } from './kurs-dokument';
import { Validators } from '@angular/forms';
import { List } from 'immutable';
// import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'yt-kurs-dokument-update',
    templateUrl: './kurs-dokument-update.component.html'
})
export class KursDokumentUpdateComponent extends BaseUpdateComponent<KursDokument> implements OnInit {

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        // protected notificationService: NotificationsService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected modalService: ModalService
    ) {
        super(activatedRoute, baseDataService, toastrService, translateService, modalService)
    }

    ngOnInit() {
        super.ngOnInit();    
        this.addValidatorToFc("Datum", Validators.required, 'required', 'KURSDOKUMENT.DATUM.VALIDATION.REQUIRED');  
    }

    onDatumChange(value) {
        if (value != null) {
            this.TransferParameters = this.TransferParameters.set(0, List([new QueryParameter('Datum', this.baseFormGroup.get("Datum").value)]))
        }
    }
    editMode: boolean = false;
    AddDocument() { }
    //Print(ID1) { }
    item: any;
    PrintKnj(item1) { }
    SaveMaster(qq) { }
}
